/* Native theme slideshow owns navigation, visibility, and editor selection.
   This element only manages hosted-video playback and cleanup. */
if (!customElements.get('fuliage-reels')) {
  customElements.define('fuliage-reels', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const {signal} = this.abort;
      // Use the existing theme section instance; Splide still owns every move.
      const connectPagination = () => {
        const instance = window.Shopify?.theme?.sections?.instances?.find(item => item.container === this);
        const slider = instance?.splideContainer;
        if (!slider || !this.querySelector('.splide.is-active')) return;
        this.paginationBoot?.disconnect();
        this.slider = slider;
        this.querySelector('[data-position-pagination]')?.remove();
        const list = document.createElement('ul');
        list.className = 'splide__pagination absolute inline-block left-0 ml-1 lg:ml-4 bottom-3 w-auto text-current';
        list.dataset.positionPagination = '';
        this.querySelector('.splide').append(list);
        const update = () => {
          const count = Math.max(1, slider.length - Number(slider.options.perPage) + 1);
          if (list.children.length !== count) {
            list.replaceChildren();
            for (let index = 0; index < count; index++) {
              const item = document.createElement('li');
              const button = document.createElement('button');
              button.type = 'button';
              button.className = 'splide__pagination__page';
              button.setAttribute('aria-label', slider.i18n.slideX.replace('%s', index + 1));
              button.setAttribute('aria-controls', slider.Components.Elements.track.id);
              button.addEventListener('click', () => slider.go(index), {signal});
              item.append(button);
              list.append(item);
            }
          }
          const current = Math.min(slider.index, count - 1);
          [...list.children].forEach((item, index) => {
            const button = item.firstElementChild;
            button.classList.toggle('is-active', index === current);
            button.setAttribute('aria-current', index === current ? 'true' : 'false');
          });
          list.hidden = count <= 1;
        };
        this.paginationEvents = 'moved.fuliagePositions updated.fuliagePositions resized.fuliagePositions refresh.fuliagePositions';
        slider.on(this.paginationEvents, update);
        update();
      };
      this.paginationBoot = new MutationObserver(connectPagination);
      this.paginationBoot.observe(this, {childList:true,subtree:true,attributes:true,attributeFilter:['class']});
      connectPagination();
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-play]');
        if (!button) return;
        const video = button.parentElement.querySelector('template').content.firstElementChild.cloneNode(true);
        this.querySelectorAll('video').forEach(other => other.pause());
        button.replaceWith(video);
        video.focus();
        video.play().catch(() => {});
      }, {signal});
      this.addEventListener('play', event => {
        this.querySelectorAll('video').forEach(video => { if (video !== event.target) video.pause(); });
      }, {capture:true, signal});
      this.observer?.disconnect();
      this.observer = new MutationObserver(() => {
        this.querySelectorAll('.splide__slide[inert] video').forEach(video => video.pause());
      });
      this.observer.observe(this, {subtree:true,attributes:true,attributeFilter:['inert']});
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.paginationBoot?.disconnect();
      if (this.slider && this.paginationEvents) this.slider.off(this.paginationEvents);
      this.querySelectorAll('video').forEach(video => video.pause());
    }
  });
}
